'use es6';

import { List, fromJS } from 'immutable';
import Actions from 'AdsUI/lib/Actions';
import { ColumnDataRecord } from 'AdsUI/records/reporting/ColumnRecords';
export default ((state = ColumnDataRecord(), action) => {
  const {
    type,
    payload
  } = action;

  if (!payload) {
    return state;
  }

  switch (type) {
    case Actions.COLUMN_ORDER_FETCH_SUCCEEDED:
      {
        const {
          allowed,
          selected,
          displayStrings
        } = payload;
        return state.merge({
          displayStrings,
          allowed: fromJS(allowed),
          selected: fromJS(selected)
        });
      }

    case Actions.COLUMN_ORDER_SET:
      {
        const {
          entityType,
          network,
          columnOrder
        } = payload;
        return state.setIn(['selected', network, entityType], List(columnOrder));
      }

    default:
      {
        return state;
      }
  }
});